const iAction = {
    id: null,
    skiplogicActionId: null,
    kind: 'ShowQuestion',
    pageId: null,
}

class SkipLogicAction {
    constructor(action) {
        Object.assign(this, iAction)
        Object.assign(this, action)
    }

    toJSON() {
        const json = {
            id: this.id,
            skipLogicActionId: this.skipLogicActionId,
            pageQuestionId: this.pageQuestionId,
            kind: this.kind,
            pageId: this.pageId,
            optionId: this.optionId,
        }
        return json
    }
}

export default SkipLogicAction
